export default "__VITE_ASSET__425b5a03__"